// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-254dd092] {\n  width: 40px;\n  height: 40px;\n  color: #fff;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
